import * as Yup from 'yup';

export const WhatsappConfigFormSchema = Yup.object().shape({
  phoneNumberId: Yup.string().nullable(),
  whatsappBusinessAccountId: Yup.string().nullable(),
  activated: Yup.boolean(),
});

export type TWhatsappConfigFormSchema = Yup.InferType<typeof WhatsappConfigFormSchema>;

export const whatsappFormSchemaDefaultValues: TWhatsappConfigFormSchema = {
  phoneNumberId: '',
  whatsappBusinessAccountId: '',
  activated: false,
};
